import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 啟用產品。
 * `POST /crm/product/{id}/activate`；body `{ updatedAt }`。
 *
 * @param {string} id
 * @param {{ updatedAt?: string }} [payload]
 */
export async function activateProduct(id, payload = {}) {
  const { data: raw } = await request.post(
    `/crm/product/${id}/activate`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
